import api from '@/utils/axios';

/**
 * 채팅 관련 API 서비스
 * - 채팅 로그 조회
 * - 채팅 로그 추가
 * - 채팅 백업
 * - 미분류 채팅 조회
 */
const chatService = {
  // ================================
  // 채팅 조회 API
  // ================================
  async getChatsByPrefix(date, prefix) {
    try {
      const data = await api.get('/api/v1/chat', {
        date,
        prefix,
      });
      return data;
    } catch (error) {
      console.error('채팅 조회 실패:', error);
      throw error;
    }
  },

  async getUncategorizedChats(date) {
    try {
      const data = await api.get('/api/v1/chat/uncategorized', {
        date,
      });
      return data;
    } catch (error) {
      console.error('미분류 채팅 조회 실패:', error);
      throw error;
    }
  },

  // ================================
  // 채팅 로그 관리 API
  // ================================
  async backupChatLog(date) {
    try {
      await api.post('/api/v1/chat/log/backup', null, {
        date,
      });
    } catch (error) {
      console.error('채팅 로그 백업 실패:', error);
      throw error;
    }
  },
};

export default chatService;
